// extracted by mini-css-extract-plugin
export default {"icons":"DetailCards_icons__df6B5","greyText":"DetailCards_greyText__p-NYj"};